<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiModalSide" });
</script>
<template>
    <Transition v-on="ons.animation">
        <div class="ui-modal-aside ui-mask" v-show="open" ref="main" @click.self="closeModal" :style="{ zIndex: zIndex }">
            <div class="ui-modal-container" ref="container" v-bind="binds.container">
                <!-- * 关闭按钮 -->
                <div class="ui-modal-close" v-if="close" :style="{ 'font-size': closeSize + 'px' }">
                    <UiIcon :name="closeIcon" @click="closeModal" />
                </div>

                <!-- * 内容 -->
                <div class="ui-modal-content" ref="content" v-bind="binds.content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script lang="ts" setup>
//* Vue
import { onMounted, onBeforeUnmount } from "vue";
//* 组件
import UiIcon from "@various/components/icon";
//* 全局属性
import { node } from "@various/utils";
//* 组件属性
import { UiModalSidePropsOption, UiModalSideEmits } from "./index";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(UiModalSideEmits);
const define = defineProps(UiModalSidePropsOption);

//* 组合函数
const { ons, refs, nodes, binds, methods } = useComposable(define, emits);
const { open } = refs;
const { main, container } = nodes;
const { openModal, closeModal, scrollTo } = methods;

//* 挂载函数
onMounted(() => {
    if (main.value) {
        node.append(document.body, main.value);
    }
});

//* 卸载函数
onBeforeUnmount(() => {
    document.body.style.overflow = "";
    if (main.value) {
        node.remove(document.body, main.value);
    }
});

//* 组件属性导出
;
defineExpose({ openModal, closeModal, scrollTo });
</script>
